import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { PropertySchema } from "../../properties/response/ShowPropertiesResponse";

const RoomTypeSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    // Nullable: property deactivation nulls this server-side (DeactivatePropertyChannexJob).
    channex_id: z.string().uuid().nullable(),
    name: z.string(),
    description: z.nullable(z.string()),
    no_of_beds: z.number(),
    cut_of_days: z.number(),
    is_free_allotment: z.boolean(),
    is_auto_assign: z.boolean(),
    is_dynamic_pricing: z.boolean(),
    total_rooms: z.number(),
    created_at: z.string(),
    updated_at: z.string(),
    occ_adults: z.number(),
    occ_children: z.number(),
    occ_infants: z.number(),
    default_occupancy: z.number(),
    room_kind: z.string(),
    capacity: z.number(),
});

const RoomSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    room_type_id: z.string().uuid(),
    room_number: z.string(),
    status: z.string(),
    condition: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

const RoomMaintenanceSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    room_type_id: z.string().uuid(),
    room_id: z.string().uuid(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    note: z.string().nullable(),
    status: z.number(),
    created_at: z.string(),
    updated_at: z.string(),
    property: PropertySchema,
    room_type: RoomTypeSchema,
    room: RoomSchema,
});

const IndexRoomMaintenanceResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(RoomMaintenanceSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export { IndexRoomMaintenanceResponse };
export type IndexRoomMaintenanceResponseType = z.infer<typeof IndexRoomMaintenanceResponse>;
export type RoomMaintenanceType = z.infer<typeof RoomMaintenanceSchema>;
